'use client'

import dynamic from 'next/dynamic'
import { CookieBanner } from '@/components/cookie-banner'
import { UnregisterSW } from '@/components/unregister-sw'

// Dynamic imports para componentes que solo se cargan en el cliente
const TrustpilotInit = dynamic(
  () =>
    import('@/components/trustpilot-init').then(mod => ({
      default: mod.TrustpilotInit,
    })),
  { ssr: false, loading: () => null }
)

export function ClientComponents() {
  return (
    <>
      {/* Trustpilot Init - se carga en el head dinámicamente */}
      <TrustpilotInit />

      {/* Cookie banner */}
      <CookieBanner />
      <UnregisterSW />
    </>
  )
}
